// @flow
import PersistenceRegistry from '../../../react/features/base/redux/PersistenceRegistry';
import ReducerRegistry from '../../../react/features/base/redux/ReducerRegistry';
import { AUTO_PIP, CUSTOM_AUTOSTART_RECORDING, CUSTOM_AUTOSTART_TRANSCRIPTION, CUSTOM_NOISE_SUPPRESSION, CUSTOM_NOISE_SUPPRESSION_TYPE, CUSTOM_PRE_JOIN_SCREEN, CUSTOM_PRE_JOIN_SCREEN_EXTERNAL, SELECTED_AUDIO_STATE, SELECTED_LANG_TRANSCRIPTION, SELECTED_VIDEO_STATE, SELECT_VISITOR_MUTE_STATE, UPDATE_IDS_VALUES_NOISE_SUPPRESSION } from './actionTypes';
/**
 * The redux subtree of this feature.
 */
const STORE_NAME = 'wildix/customStorageSettings';
const defaultState = {
    isAutoPip: true,
    noiseSuppression: true,
    newNoiseSuppressionType: undefined,
    audioDeviceIDs: {},
    langTranscription: 'en-US',
    startWithAudioMutedWildix: false,
    startWithVideoMutedWildix: true,
    isTranscriptionAutostart: true,
    isRecordingAutostart: true,
    visitorMute: false,
    isPreJoinScreen: false,
    isPreJoinScreenExternal: true
};
/**
 * Sets up the persistence of the feature {@code buttons}.
 */
PersistenceRegistry.register(STORE_NAME);
ReducerRegistry.register(STORE_NAME, (state = defaultState, action) => {
    switch (action.type) {
        case CUSTOM_NOISE_SUPPRESSION:
            return {
                ...state,
                noiseSuppression: action.noiseSuppression
            };
        case AUTO_PIP:
            return {
                ...state,
                isAutoPip: action.isAutoPip
            };
        case SELECT_VISITOR_MUTE_STATE:
            return {
                ...state,
                visitorMute: action.visitorMute
            };
        case CUSTOM_NOISE_SUPPRESSION_TYPE:
            return {
                ...state,
                newNoiseSuppressionType: action.newNoiseSuppressionType
            };
        case CUSTOM_AUTOSTART_TRANSCRIPTION:
            return {
                ...state,
                isTranscriptionAutostart: action.isTranscriptionAutostart
            };
        case CUSTOM_AUTOSTART_RECORDING:
            return {
                ...state,
                isRecordingAutostart: action.isRecordingAutostart
            };
        case CUSTOM_PRE_JOIN_SCREEN:
            return {
                ...state,
                isPreJoinScreen: action.isPreJoinScreen
            };
        case CUSTOM_PRE_JOIN_SCREEN_EXTERNAL:
            return {
                ...state,
                isPreJoinScreenExternal: action.isPreJoinScreenExternal
            };
        case UPDATE_IDS_VALUES_NOISE_SUPPRESSION:
            return {
                ...state,
                audioDeviceIDs: {
                    ...state.audioDeviceIDs,
                    [action.deviceObject.deviceID]: action.deviceObject.value
                }
            };
        case SELECTED_LANG_TRANSCRIPTION:
            return {
                ...state,
                langTranscription: action.lang
            };
        case SELECTED_AUDIO_STATE:
            return {
                ...state,
                startWithAudioMutedWildix: action.audio
            };
        case SELECTED_VIDEO_STATE:
            return {
                ...state,
                startWithVideoMutedWildix: action.video
            };
    }
    return state;
});
